module.exports = __webpack_public_path__ + "static/media/icon-score-scale.1ac00180.png";